/* flow */
import React, { PureComponent } from 'react'
import { doScrolling } from './utils'

type Props = {
  offset: number,
  appAnchor: string
}

type State = {
  showScroll: boolean
}

export default class ScrollerUp extends PureComponent<Props, State> {
  state = {
    showScroll: false
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.waitForPause(500, this.handleScroll))
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll)
  }

  waitForPause (ms: number, callback: (e: SyntheticEvent<HTMLElement>) => void) {
    let timer
    return (e: SyntheticEvent<HTMLElement>) => {
      clearTimeout(timer)
      timer = setTimeout(() => callback(e), ms)
    };
  }
  
  handleScroll = (e: SyntheticEvent<HTMLElement>) => {
    const { offset, appAnchor } = this.props
    const appElement = document.querySelector(appAnchor)
    const top = window.pageYOffset + appElement.getBoundingClientRect().top
    const height = appElement.getBoundingClientRect().height
    let showScroll = false
    if (window.pageYOffset > top + offset && window.pageYOffset + window.innerHeight - 50 <= top + height ) {
      showScroll = true
    }
    this.setState({ showScroll })
  }

  scrollToTop = (e: SyntheticEvent<HTMLButtonElement>) => {
    doScrolling(this.props.appAnchor, 500)
  }
  
  render () {
    if (this.state.showScroll) {
      return <button onClick={this.scrollToTop} className="ui icon button huge ac-scroll-button">
        <i className="chevron up icon"></i>
      </button>
    }
    return null
  }
}


// WEBPACK FOOTER //
// ./src/ScrollerUp.js